import ENDPOINTS from './endPoints';
import apiService from './service/apiService';

export interface EditContentPayload {
  content_id: string | number;
  post_copy: string;
  visual_brief?: {
    image_prompt?: string;
    image_style?: string;
    aspect_ratio?: string;
    video_idea?: string;
  };
}

/**
 * Edit content (social media post, flyer, etc.)
 */
export const editContent = async (
  contentId: string,
  restaurantId: string,
  payload: {
    post_copy: string;
    subject_line?: string;
    visual_brief?: any;
  }
): Promise<any> => {
  const formData = new FormData();
  formData.append('content_id', contentId);
  formData.append('restaurant_id', restaurantId);
  formData.append('image', ''); // Empty image value
  
  // Build content object - include subject_line if present (for Email)
  const contentObj: any = {
    post_copy: payload.post_copy,
    visual_brief: payload.visual_brief
  };
  
  if (payload.subject_line) {
    contentObj.subject_line = payload.subject_line;
  }
  
  formData.append('content', JSON.stringify(contentObj));

  // URL uses restaurant_id, content_id is only in FormData
  return await apiService.put({
    endpoint: `${ENDPOINTS.editFlyer}/${restaurantId}`,
    body: formData
  });
};

/**
 * Create direct campaign
 */
export const createDirectCampaign = async (
  restaurantId: string,
  payload: {
    campaign_title: string;
    campaign_date: string;
    campaign_description: string;
    campaign_type: string;
    flyer?: File | null;
  }
): Promise<any> => {
  const formData = new FormData();
  formData.append('campaign_title', payload.campaign_title);
  formData.append('campaign_date', payload.campaign_date);
  formData.append('campaign_description', payload.campaign_description);
  formData.append('campaign_type', payload.campaign_type);
  
  // Add flyer if provided, otherwise send empty
  if (payload.flyer) {
    formData.append('flyer', payload.flyer);
  } else {
    formData.append('flyer', '');
  }

  return await apiService.post({
    endpoint: `${ENDPOINTS.directCampaign}/${restaurantId}`,
    body: formData
  });
};

/**
 * Regenerate flyer content
 */
export const regenerateFlyer = async (
  contentId: string,
  restaurantId: string,
  flyerContent: {
    Header: string;
    Description: string;
    'Offer Details': string;
    Footer: string;
    hero_image_prompt: string;
  }
): Promise<any> => {
  const formData = new FormData();
  formData.append('content_id', contentId);
  // Don't send restaurant_id in payload - it's already in the URL
  formData.append('image', ''); // Empty image value
  
  // Build content object with flyer fields
  const contentObj = {
    Header: flyerContent.Header,
    hero_image_prompt: flyerContent.hero_image_prompt,
    Description: flyerContent.Description,
    'Offer Details': flyerContent['Offer Details'],
    Footer: flyerContent.Footer
  };
  
  formData.append('content', JSON.stringify(contentObj));

  // Restaurant ID is only in URL, not in FormData payload
  return await apiService.put({
    endpoint: `${ENDPOINTS.editFlyer}/${restaurantId}`,
    body: formData
  });
};

export default {
  editContent,
  regenerateFlyer,
  createDirectCampaign
};
